<template>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='name' :columns='columns' :data-source='data'>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
</template>

<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getTotal } from "@/api/order";
import { iscode } from "@/utils/app";
import store from "@/store";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 5,
};
export default {
  name: "pointsList",
  components: {},
  props: {
    order_no: {
      type: String,
    },
  },
  setup(props, { emit }) {
    // // 初始化 分页信息和筛选项信息
    const search = ref({ ...defSearch });
    // 列表数据和列头配置
    const data = ref([]);
    const state = reactive({
      listLoading: false,
      total: 1,
      time: [],
    });
    let columns = [
      {
        title: "兑换码",
        dataIndex: "redeem_code",
        key: "redeem_code",
      },
      {
        title: "状态",
        dataIndex: "status_text",
        key: "status_text",
      },
      {
         title: "添加时间",
        dataIndex: "create_time",
        key: "create_time",
        slots: { customRender: "create_time" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    const _lodash = inject("_lodash");

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getTotal({
          ...values,
          order_no:props.order_no,
        }).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    onMounted(() => {     
      initData(search.value);
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
    };
  },
};
</script>